import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-I1 — CHASSEUR. Le poste de tir qui NE TIENT PAS EN PLACE.
 *
 *  Il descend à mi-hauteur puis balaie tout un pan de l'écran, gauche-droite,
 *  vite et large, en lâchant de courtes RAFALES visées. Ce n'est ni le Rôdeur
 *  (qui traverse une fois et sort) ni le Mitrailleur (qui se poste et ne bouge
 *  plus) : c'est une plateforme de tir MOBILE.
 *
 *  ── Ce qu'il enseigne ──
 *  Que la source du danger se déplace en même temps que lui. Contre le
 *  Mitrailleur, on lit d'où part la salve une fois pour toutes et on s'écarte de
 *  cette colonne ; contre le Chasseur, la colonne suit l'appareil. Tenir son
 *  déplacement d'esquive ne suffit plus — il faut le RÉORIENTER en continu vers
 *  un émetteur qui glisse. C'est la première fois que le joueur doit pister un
 *  tireur au lieu d'un tir.
 *
 *  ── Pourquoi le balayage vient du moteur, pas d'un hook ──
 *  Un va-et-vient latéral à hauteur constante EST le mouvement Hover : on lui
 *  donne juste une amplitude franche. On ne réécrit jamais dans un hook ce que
 *  le moteur sait déjà faire — le hook est réservé à ce qu'aucune forme ne porte
 *  (voir la Guêpe, l'Escadrille).
 *
 *  ── Ce qui garde l'esquive vivante ──
 *  La vitesse de pointe du balayage (l'amplitude, 430 u/s) reste SOUS les 480 du
 *  joueur : un joueur qui se déplace franchement peut toujours reprendre l'avance
 *  sur le Chasseur et sortir de son arc de tir. Et la rafale reste courte — trois
 *  traits par cycle de 1,5 s —, jamais un flot continu qui saturerait l'écran. */
export default defineEnemy({
  id: 'chasseur',
  rank: Rank.Standard,
  hp: 90,
  visualRadius: 22,
  score: 200,
  telegraph: 0.8,
  drops: 2,
  // Hover à GRANDE amplitude : il descend jusqu'à sa hauteur de croisière puis
  // balaie. L'amplitude est une vitesse de pointe (u/s) ; à 430, sous les 480 du
  // joueur, le balayage est vif mais toujours distançable. Déplacement latéral
  // résultant ≈ ±215 u (amplitude ÷ fréquence).
  motion: { kind: Motion.Hover, speed: 260, amplitude: 430, frequency: 2.0, holdY: 180 },
  emitter: {
    pattern: Pattern.Burst,
    every: 1.5,
    count: 3,
    // Salve serrée dans le temps : une giclée, pas des tirs isolés.
    burstGap: 0.09,
    // Léger balayage de la salve elle-même : combiné au déplacement du porteur,
    // il interdit de se contenter d'un pas de côté figé.
    spreadDeg: 8,
    // 760 u/s : un trait rapide, sous le plafond de 1 500 même majoré du palier
    // Vétéran (×1,12 = 851).
    speed: 760,
    firstDelay: 1.4,
    family: Fam.EnemyPink,
  },
});
